export default import.meta.ROLLDOWN_FILE_URL_5ueHAtn9JtiQ3lCiqsnAfg